import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config';
import MemberRow from './MemberRow';

export default function MembersTab({ deptId, onCount }) {
  const [members, setMembers] = useState(null);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const activeRef = useRef(true);

  const load = useCallback(async () => {
    setMembers(null);
    setError('');
    try {
      const r = await axios.get(`${API_BASE_URL}/api/dept/${deptId}/roster`, { withCredentials: true });
      const list = r.data.members || [];
      if (!activeRef.current) return;
      setMembers(list);
      if (onCount) onCount(list.length);
    } catch {
      if (activeRef.current) setError("Couldn't load the member roster.");
    }
  }, [deptId, onCount]);

  useEffect(() => {
    activeRef.current = true;
    load();
    return () => { activeRef.current = false; };
  }, [load]);

  const filtered = (members || []).filter((m) => {
    const q = search.trim().toLowerCase();
    return !q || `${m.name} ${m.email}`.toLowerCase().includes(q);
  });

  return (
    <div>
      <div className="dept2-toolbar">
        <label className="visually-hidden" htmlFor="dept2-member-search">Search members</label>
        <input
          id="dept2-member-search"
          className="search-input"
          type="search"
          placeholder="Search members by name or email…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          autoComplete="off"
        />
      </div>

      {error && (
        <div className="dept2-error" role="alert">
          <p>{error}</p>
          <button type="button" className="btn btn-secondary btn-small" onClick={load}>Try again</button>
        </div>
      )}

      {!error && members === null && (
        <ul className="dept2-roster" role="status" aria-busy="true" aria-label="Loading members">
          {Array.from({ length: 6 }).map((_, i) => <li key={i} className="dept2-skeleton" aria-hidden="true" />)}
        </ul>
      )}

      {!error && members && members.length === 0 && (
        <div className="dept2-empty"><p>No active members in this department yet.</p></div>
      )}

      {!error && filtered.length > 0 && (
        <ul className="dept2-roster">
          {filtered.map((m) => <MemberRow key={m.id} member={m} />)}
        </ul>
      )}

      {!error && members && members.length > 0 && filtered.length === 0 && (
        <div className="dept2-empty"><p>No members match your search.</p></div>
      )}
    </div>
  );
}
